import React from 'react'
import { Link, PdfFile, Saw, chemistryTheme } from 'chemistry'

const ActionButtons = ({ contentfulTranslations, fileAttachment }) => {
  const { url, title } = fileAttachment || {}
  return (
    <div className='buy-list-actions-container flex gap-16'>
      <Link variant='standard' onClick={() => window.print()} target='_blank' w={{ base: 'auto' }} textAlign='center'>
        <PdfFile color={chemistryTheme.colors.black[400]} />
        {contentfulTranslations.print}
      </Link>
      {Boolean(url) && (
        <Link
          href={url}
          title={title || ''}
          target='_blank'
          variant='standard'
          w={{ base: 'auto' }}
          textAlign='center'
          download
        >
          <Saw color={chemistryTheme.colors.black[400]} />
          {contentfulTranslations.seeList}
        </Link>
      )}
    </div>
  )
}

export default ActionButtons
